import { memo } from "react"

const NotFound = () => {

  return (
    <div className="">404</div>
  )
}

export default memo(NotFound)